(function() {
    
    angular
    	.module('app')
    	.component('portal', {
    		templateUrl: 'modules/portals/pages/portal.html',
    		controller: Portal,
    		bindings: {
    			permissions: '<',
                portalTypes: '<'
    		}
    	});

    function Portal() {}
    
})();